// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createDataProvider } from '../data-provider';

/** Represents a benchmark option from a saved portfolio */
export interface BenchmarkOption {
  /** The unique identifier for the benchmark (typically the ticker) */
  value: string;

  /** The display name or description of the benchmark */
  label: string;

  /** The ticker symbol of the benchmark */
  ticker: string;
}

export interface PortfoliosProviderProps {
  /** Optional list of saved benchmark options to display in benchmark selectors */
  readonly savedBenchmarks?: BenchmarkOption[];
}

export const usePortfoliosFactory = ({
  savedBenchmarks = [],
}: PortfoliosProviderProps = {}) => {
  return {
    savedBenchmarks,
  } as const;
};

export const {
  usePortfoliosData,
  PortfoliosProvider,
  PortfoliosConsumer,
  PortfoliosDataContext,
  withPortfolios,
} = createDataProvider({
  name: 'Portfolios',
  factory: usePortfoliosFactory,
});
